// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'babel-polyfill'
import router from './router'
import Explore from 'iexplore'
import store from './store/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import '../static/css/elementend.css'
import './styles/reset.css'

import axioss from 'axios'

Vue.prototype.$axios = axioss;

import filters from'./filters/index'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});



//引用图片放大器
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: {
    'inline': true,
    'button': true,
    'navbar': true,
    'title': true,
    'toolbar': true,
    'tooltip': true,
    'movable': true,
    'zoomable': true,
    'rotatable': true,
    'scalable': true,
    'transition': true,
    'fullscreen': true,
    'keyboard': true,
    'url': 'data-source'
  }
})


import GisMap from 'vue-ly-map'
//引用地图
import Maps from 'at-leaflet'

Vue.config.productionTip = false

Vue.use(Explore)
Vue.use(ElementUI)
Vue.use(GisMap)
Vue.use(Maps)

router.beforeEach((to, from, next) => {
  var isLogin = sessionStorage.islogin
  if (!isLogin && to.path != '/login' && to.path != '/registry' && to.path != '/forget') {
    next('/login')
  } else if (isLogin && to.path == '/login') {
    next('/')
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js